import { render, staticRenderFns } from "./delete-folder.vue?vue&type=template&id=7b87870d&scoped=true&"
import script from "./delete-folder.vue?vue&type=script&lang=js&"
export * from "./delete-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b87870d",
  null
  
)

export default component.exports